import type { DashboardQueryKey } from '@h20/contracts/types/api/dashboard/DashboardQueryCatalog';
import type { DashboardColumnDefinition } from './column-definition';
import { EXAMPLE_COUNT_COLUMNS } from './example-count.columns';
import { FORM_MISSINGNESS_COLUMNS } from './form-missingness.columns';

/** The columns for each query, where a query with no entry just uses the defaults for its types. */
export type GridColumnRegistry = {
    readonly [TKey in DashboardQueryKey]?: readonly DashboardColumnDefinition<TKey>[];
};

export const GRID_COLUMN_REGISTRY: GridColumnRegistry = {
    exampleCount: EXAMPLE_COUNT_COLUMNS,
    formMissingness: FORM_MISSINGNESS_COLUMNS,
};
